// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2p3rN","tab":"PApLC","link":"_1NzLe"};